var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.438,
    height: 26.438,
    viewBox: "0 0 26.438 26.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M27,13.781A13.219,13.219,0,1,1,13.781.563,13.219,13.219,0,0,1,27,13.781Zm-14.748,7,9.807-9.807a.853.853,0,0,0,0-1.206L20.854,8.561a.853.853,0,0,0-1.206,0l-8,8L7.915,12.825a.853.853,0,0,0-1.206,0L5.5,14.031a.853.853,0,0,0,0,1.206l5.543,5.543a.853.853,0,0,0,1.206,0Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#38b970"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.798546c3e7f8a26f2626b1ac92cef4b9.svg";
export { ForwardRef as ReactComponent };